import React, { useContext } from 'react';
import { SafeAreaView, View } from 'react-native';
import { ApolloProvider } from '@apollo/client';
import DataTable from '@preflighttech/preflight-tables';
import styled from 'styled-components/native';

import ClientContext from 'app/src/contexts/ClientContext';
import { Text } from 'app/src/styles';
import tableStyles from 'app/src/styles/table';
import { Router } from 'app/src/utils/routing';

import Menu from './Menu';
import Routes from './Routes';

const Screen = styled(SafeAreaView)`
  min-height: 100vh;
`;

const PTI = () => {
  const { apolloClientForPTI, currentUser } = useContext(ClientContext);

  if (!['2', '95'].includes(currentUser?.id)) {
    return (
      <Screen>
      </Screen>
    );
  }

  return (
    <ApolloProvider client={apolloClientForPTI}>
      <Screen>
        <Router>
          <Menu />

          <DataTable.Provider
            pageLength={100}
            lengthMenu={ [10, 25, 50, 100, 'All'] }
            styles={tableStyles}
            htmlTable
          >
            <View style={{ margin: 10 }}>
              <Routes />
            </View>
          </DataTable.Provider>
        </Router>
      </Screen>
    </ApolloProvider>
  );
};

export default PTI;
